import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-2 border-black rounded-full size-7 lg:size-9 font-bold text-base lg:text-lg flex items-center justify-center shrink-0" }




export default /*@__PURE__*/_defineComponent({
  __name: 'CircleComponent',
  props: {
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.value), 1))
}
}

})